import mitt from 'mitt'
import Global from '@/Mixins/Global.js'

export default defineNuxtPlugin(async (nuxtApp) => {
  nuxtApp.vueApp.config.globalProperties.eventHub = mitt()
  nuxtApp.vueApp.provide('eventHub', nuxtApp.vueApp.config.globalProperties.eventHub)
  nuxtApp.vueApp.mixin(Global)
})
